"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
require("reflect-metadata");
const class_transformer_1 = require("class-transformer");
const nanoid_1 = require("nanoid");
const pokersolver_1 = require("pokersolver");
const rxjs_1 = require("rxjs");
const __1 = require("../");
const BetUndefinedForPlayer_1 = require("../error/table/BetUndefinedForPlayer");
const CannotStackPotsBeforeShowdown_1 = require("../error/table/CannotStackPotsBeforeShowdown");
const CantCallNoBetError_1 = require("../error/table/CantCallNoBetError");
const PlayOutOfTurnError_1 = require("../error/table/PlayOutOfTurnError");
const TriedToPlayBlindsOutOfOrderError_1 = require("../error/table/TriedToPlayBlindsOutOfOrderError");
const lang_1 = require("../lang");
const TableEvent_1 = require("../messaging/event/TableEvent");
const EventSourced_1 = require("../messaging/EventSourced");
const Logger_1 = require("../util/Logger");
const ActionEvaluator_1 = require("./ActionEvaluator");
const Bet_1 = require("./Bet");
const BettingRecommender_1 = require("./BettingRecommender");
const Blind_1 = require("./Blind");
const Board_1 = require("./Board");
const Player_1 = require("./Player");
const Pot_1 = require("./Pot");
const GameMode_1 = require("./states/GameMode");
const GameState_1 = require("./states/GameState");
const GameStateAction_1 = require("./states/GameStateAction");
const GameStateReducer_1 = require("./states/GameStateReducer");
const config = {
    AUTO_START: false,
    DEFAULT_BIG_BLIND: 100,
    TOURNAMENT_BIG_BLIND: 100,
    BLIND_LEVELS: [
        200, 300, 400, 500, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000, 3000,
        4000, 5000, 6000,
    ],
    MIN_PLAYERS: 2,
    MAX_PLAYERS: 9,
    PLAYERS_COLORS: [
        'red',
        'blue',
        'green',
        'orange',
        'pink',
        'crimson',
        'purple',
        'teal',
        'lightblue',
    ],
};
class Table extends EventSourced_1.Evented {
    constructor(name, id = nanoid_1.nanoid(), bigBlind = config.DEFAULT_BIG_BLIND, minPlayers = config.MIN_PLAYERS, maxPlayers = config.MAX_PLAYERS, autostart = config.AUTO_START, subscriber) {
        super(id);
        this.name = name;
        this.bigBlind = bigBlind;
        this.minPlayers = minPlayers;
        this.maxPlayers = maxPlayers;
        this.autostart = autostart;
        this.players = [];
        this.leftPlayers = [];
        this.button = -1;
        this.currentPlayer = 0;
        this.minimumRaise = config.DEFAULT_BIG_BLIND;
        this.minimumBet = config.DEFAULT_BIG_BLIND;
        this.previousPlayerId = '';
        this.buttonPlayerId = '';
        this.currentPlayerId = '';
        this.gameId = '';
        this.gameName = '';
        this.smallBlindLeft = false;
        this.bigBlindLeft = false;
        this.smallBlindFold = false;
        this.bigBlindFold = false;
        this.blindTimerCheckpoint = 0;
        this.blindTimerCountdown = 5;
        this.gameStartTime = 0;
        this.gamePauseTime = 0;
        this.nextBlindIndex = 0;
        this.lastPlayerAction = '';
        this.event$ = new rxjs_1.Subject();
        this.state = GameState_1.GameStates.PreGame;
        this.mode = GameMode_1.GameModes.Default;
        this.blinds = new Blind_1.Blind(bigBlind);
        this.nextBlinds = new Blind_1.Blind(bigBlind * 2);
        this.board = new Board_1.Board(this.blinds);
        if (subscriber) {
            this.event$.subscribe(subscriber);
        }
        this.update(TableEvent_1.TableEvents.tableCreatedEvent(this));
    }
    addPlayer(name, chips, userId, userRoles, lock) {
        let player = undefined;
        if (userId) {
            player = this.getPlayerByUserId(userId);
        }
        if (typeof player === 'undefined') {
            if (userId === name) {
                name = lang_1.Language.strings.table.autoPlayerName(this.totalPlayers() + 1);
            }
            player = new Player_1.Player(name, chips, userId, userRoles);
            if (lock) {
                this.setPlayerAsObserver(player);
            }
            else {
                this.addPlayerToPlay(player);
            }
        }
        return player;
    }
    addPlayerToPlay(player) {
        Logger_1.logger.info(`playingPlayers, ${this.playingPlayers().length}`);
        if (this.board.canSeatNewPlayers() &&
            this.playingPlayers().length <= config.MAX_PLAYERS) {
            if (this.players.length >= config.MAX_PLAYERS ||
                (GameMode_1.GameModes.isTournament(this.mode) &&
                    this.fecthTournamentRunningTime() > 15)) {
                this.setPlayerAsObserver(player);
            }
            else {
                player.beginPlay();
                if (!this.getPlayerById(player.getId())) {
                    this.players.splice(this.getButtonPlayerIndex(), 0, player);
                }
                if (!this.board.pot.getPlayerIds().includes(player.getId())) {
                    this.board.pot.players.push(player);
                }
                this.updatePlayersFromWaitlist();
                this.adjustTheButton();
                this.setColorForPlayer(player.getId());
                this.update(TableEvent_1.TableEvents.playerJoinedEvent(this, player));
            }
        }
        else {
            Logger_1.logger.info(`all players, ${this.players.length}`);
            if (this.players.length >= config.MAX_PLAYERS ||
                (GameMode_1.GameModes.isTournament(this.mode) &&
                    this.fecthTournamentRunningTime() > 15)) {
                this.setPlayerAsObserver(player);
            }
            else {
                this.waitlistPlayer(player);
                this.adjustButtonForWaitList(player);
                this.update(TableEvent_1.TableEvents.handCurrentPlayerEvent(this, this.getCurrentPlayer()));
                this.startGameWithWaitListPlayers();
            }
        }
    }
    setPlayerAsObserver(player) {
        player.observer();
        if (!this.getPlayerById(player.getId())) {
            if (this.players[this.currentPlayer]) {
                this.previousPlayerId = this.players[this.currentPlayer].getId();
            }
            const observers = this.observerPlayers();
            player.observerId = observers.length + 1;
            this.players.push(player);
            if (this.players[this.currentPlayer] &&
                this.previousPlayerId !== this.players[this.currentPlayer].getId()) {
                this.nextTurn();
            }
        }
        this.update(TableEvent_1.TableEvents.playerObserverEvent(this, player));
    }
    fecthTournamentRunningTime() {
        Logger_1.logger.info(`${this.gameStartTime} gameStartTime ${this.getCurrentCheckpoint()} getCurrentCheckpoint`);
        const diff = Math.abs(this.gameStartTime - this.getCurrentCheckpoint());
        const minute = parseInt(((diff / (1000 * 60)) % 60).toFixed());
        Logger_1.logger.info(`${minute} minute`);
        return minute;
    }
    startGameWithWaitListPlayers() {
        if ((this.players.length >= 2 &&
            this.getSitoutList().length === this.players.length) ||
            this.getWaitlist().length === this.players.length) {
            this.newHand();
        }
    }
    waitlistPlayer(player) {
        player.wait();
        if (!this.getPlayerById(player.getId())) {
            this.previousPlayerId =
                this.currentPlayer !== -1
                    ? this.players[this.currentPlayer].getId()
                    : '';
            this.players.splice(this.getButtonPlayerIndex(), 0, player);
            this.resetPlayerSeats();
            if (this.currentPlayer !== -1 &&
                this.previousPlayerId !== this.players[this.currentPlayer].getId()) {
                this.nextTurn();
            }
        }
        this.setColorForPlayer(player.getId());
        this.update(TableEvent_1.TableEvents.playerWaitlistedEvent(this, player));
    }
    resetPlayerSeats() {
        let bets = [];
        this.players.map((player) => {
            const seatId = player.getSeatId();
            const currentSeatId = this.getPlayerIndexByPlayerId(player.getId());
            const bet = this.board.getBetForPlayerAt(seatId);
            if (player.isSittingOut() || player.isWaiting()) {
                player.setSeatId(currentSeatId);
            }
            else {
                player.setSeatId(currentSeatId);
                bets[currentSeatId] = bet;
            }
        });
        if (this.leftPlayers.length > 0) {
            this.leftPlayers.map((player) => {
                const seatId = player.getSeatId();
                const bet = this.board.getBetForPlayerAt(seatId);
                bets.push(bet);
            });
        }
        this.board.setBets(bets);
        this.leftPlayers = [];
    }
    adjustButtonForWaitList(player) {
        if (this.buttonPlayerId != '') {
            const buttonPlayerIndex = this.getPlayerIndexByPlayerId(this.buttonPlayerId);
            if (buttonPlayerIndex !== this.getButtonPlayerIndex()) {
                this.button = buttonPlayerIndex;
                if (this.players.indexOf(player) === this.currentPlayer) {
                    this.currentPlayer = this.isHeadsUpPlay()
                        ? this.getButtonPlayerIndex()
                        : this.countFromButton(3);
                    if (this.players[this.currentPlayer].isFolded() ||
                        this.players[this.currentPlayer].isWaiting() ||
                        this.players[this.currentPlayer].isSittingOut()) {
                        this.nextPlayer();
                    }
                }
            }
        }
    }
    removePlayerById(playerId) {
        return this.removePlayer(this.getPlayerById(playerId));
    }
    removePlayerByUserId(userId) {
        return this.removePlayer(this.getPlayerByUserId(userId));
    }
    removePlayer(player) {
        const playerPosition = this.getPlayerIndexByPlayerId(player.getId());
        this.update(TableEvent_1.TableEvents.playerLeftEvent(this));
        this.players[playerPosition] = undefined;
    }
    newHand() {
        this.update(TableEvent_1.TableEvents.handNewEvent(this));
    }
    pause() {
        this.update(TableEvent_1.TableEvents.tablePausedEvent(this));
    }
    unpause() {
        this.update(TableEvent_1.TableEvents.tableStartedEvent(this));
    }
    collectCards() {
        this.players.map((p) => p.returnCards());
    }
    dealCards() {
        this.activePlayers().map((p) => {
            p.getCards(this.board.dealHoleCards());
        });
        this.update(TableEvent_1.TableEvents.handDealtCardsEvent(this));
    }
    setTheButton() {
        Logger_1.logger.trace(`STB: button before moving: ${this.button}`);
        Logger_1.logger.trace(`STB: current player before moving: ${this.button}`);
        if (this.buttonPlayerId === '') {
            const activePlayers = this.activePlayers();
            this.button = this.getPlayerIndexByPlayerId(activePlayers[activePlayers.length - 1].getId());
        }
        else {
            this.button = this.countFromButton(1);
        }
        this.buttonPlayerId = this.players[this.button].getId();
        this.currentPlayer = this.isHeadsUpPlay()
            ? this.getButtonPlayerIndex()
            : this.countFromButton(3);
        this.currentPlayerId = this.players[this.currentPlayer].getId();
        this.smallBlindLeft = false;
        this.bigBlindLeft = false;
        Logger_1.logger.trace('STB: set the button: ' + this.button);
        Logger_1.logger.trace('STB: set current player: ' + this.currentPlayer);
        this.setRoleForPlayers();
    }
    setRoleForPlayers() {
        this.players.map((player, index) => {
            if (index === this.getSmallBlindPlayerIndex()) {
                player.role = 'SB';
            }
            else if (index === this.getBigBlindPlayerIndex()) {
                player.role = 'BB';
            }
            else {
                player.role = '';
            }
        });
    }
    adjustTheButton() {
        if (this.buttonPlayerId != '') {
            const buttonPlayerIndex = this.getPlayerIndexByPlayerId(this.buttonPlayerId);
            if (buttonPlayerIndex !== this.getButtonPlayerIndex()) {
                this.button = buttonPlayerIndex;
            }
        }
        if (this.currentPlayerId != '') {
            this.currentPlayer = this.getPlayerIndexByPlayerId(this.currentPlayerId);
        }
    }
    nextPlayer() {
        Logger_1.logger.trace('NCP: current player before: ' + this.currentPlayer);
        this.currentPlayer = (this.currentPlayer + 1) % this.players.length;
        const smallBlindPlayer = this.getSmallBlindPlayer();
        const bigBlindPlayer = this.getBigBlindPlayer();
        Logger_1.logger.trace('inPlayPlayers:', this.inPlayPlayers().length);
        if (this.inPlayPlayers().length >= 2 &&
            !this.board.isDeal() &&
            !this.board.hasBets()) {
            Logger_1.logger.trace(this.totalPlayers() + ' totalPlayers');
            if (!this.smallBlindFold &&
                !this.smallBlindLeft &&
                smallBlindPlayer &&
                smallBlindPlayer.isInPlay()) {
                Logger_1.logger.info('smallBlindPlayer:', smallBlindPlayer);
                if (this.isHeadsUpPlay() &&
                    (this.board.isFlop() || this.board.isTurn() || this.board.isRiver())) {
                    if (this.getBigBlindPlayer()) {
                        this.currentPlayer = this.players.indexOf(this.getBigBlindPlayer());
                    }
                }
                else {
                    if (this.getSmallBlindPlayer()) {
                        this.currentPlayer = this.players.indexOf(this.getSmallBlindPlayer());
                    }
                }
            }
            else if (!this.bigBlindFold &&
                !this.bigBlindLeft &&
                bigBlindPlayer &&
                bigBlindPlayer.isInPlay()) {
                Logger_1.logger.info('bigBlindPlayer:', bigBlindPlayer);
                this.currentPlayer = this.players.indexOf(this.getBigBlindPlayer());
            }
            else {
                this.currentPlayer = this.players.indexOf(this.getBigBlindPlayer());
                this.currentPlayer = (this.currentPlayer + 1) % this.players.length;
            }
            Logger_1.logger.trace('NCP: set player after fold turn river: ' + this.currentPlayer);
        }
        while (!this.players[this.currentPlayer].isInPlay()) {
            this.currentPlayer = (this.currentPlayer + 1) % this.players.length;
        }
        this.currentPlayerId = this.players[this.currentPlayer].getId();
        Logger_1.logger.trace('NCP: set the current player:', this.currentPlayer);
        this.resetMinimumBet();
        this.update(TableEvent_1.TableEvents.handCurrentPlayerEvent(this, this.getCurrentPlayer()));
    }
    nextTurn() {
        var _a;
        if (this.isFinished()) {
            Logger_1.logger.trace('game is finished');
        }
        this.resetMinimumBet();
        this.captureLastPlayerAction();
        if (this.allPlayersAreAllIn()) {
            this.checkHighestBetPlayer();
        }
        if (this.checkEveryoneFolded() ||
            this.playersHaveFinishedBetting() ||
            this.allPlayersAreAllIn()) {
            Logger_1.logger.trace('street is finished, capturing bets');
            this.captureBets();
            if (this.allPlayersAreAllIn() || this.oneActivePlayerLeft()) {
                Logger_1.logger.trace('only one player with actions, progressing hand to showdown');
                while (!this.board.isRiver()) {
                    if (!this.checkEveryoneFolded()) {
                        this.update(TableEvent_1.TableEvents.streetFinishedEvent(this));
                    }
                    this.nextBoardAction();
                }
            }
            if (!this.checkEveryoneFolded()) {
                this.update(TableEvent_1.TableEvents.streetFinishedEvent(this));
            }
            this.nextBoardAction();
            if (this.board.isShowdown()) {
                this.doShowdown();
                if (this.autostart) {
                    this.newHand();
                }
                else {
                    this.softReset();
                    const outPlayers = this.outPlayers();
                    if (outPlayers.length === 0) {
                        this.newHand();
                    }
                }
                this.update(TableEvent_1.TableEvents.handCurrentPlayerEvent(this, this.getCurrentPlayer()));
                this.update(TableEvent_1.TableEvents.playerEndOfTurn(this));
                return;
            }
            if (!((_a = this.getBigBlindPlayer()) === null || _a === void 0 ? void 0 : _a.isFolded())) {
                this.currentPlayer = this.countFromButton(2);
            }
            this.nextPlayer();
            this.updatePlayingPlayers();
            this.update(TableEvent_1.TableEvents.handCurrentPlayerEvent(this, this.getCurrentPlayer()));
        }
        else {
            this.nextPlayer();
        }
        const player = this.getCurrentPlayer();
        if (this.playerIsDisconnected(player)) {
            Logger_1.logger.trace('player disconnected, skipping');
            this.nextPlayer();
        }
        this.updatePlayingPlayers();
    }
    checkHighestBetPlayer() {
        const highestBetPlayer = this.allInPlayers().filter((p) => p.bet === this.board.biggestBet());
        const secondHighestBetPlayer = this.allInPlayers().find((p) => p.bet < this.board.biggestBet() &&
            p.bet === this.board.secondBiggestBet());
        if (highestBetPlayer.length === 1 && secondHighestBetPlayer) {
            const player = highestBetPlayer[0];
            player.chips = player.bet - secondHighestBetPlayer.bet;
            player.bet = secondHighestBetPlayer.bet;
            const updateBet = new Bet_1.Bet(player.bet, Bet_1.BetKind.BET);
            const index = player.bets.length - 1;
            player.bets.splice(index, 1);
            player.bets.push(updateBet);
            const currentSeatId = this.getPlayerIndexByPlayerId(player.getId());
            this.board.doBetForPlayerAt(currentSeatId, updateBet);
        }
        this.update(TableEvent_1.TableEvents.higestBetPlayerEvent(this, this.getCurrentPlayer()));
    }
    resetMinimumBet() {
        if (this.board.isFlop() || this.board.isTurn() || this.board.isRiver()) {
            this.minimumRaise = GameMode_1.GameModes.isTournament(this.mode)
                ? this.minimumBet
                : config.DEFAULT_BIG_BLIND;
        }
    }
    captureLastPlayerAction() {
        this.update(TableEvent_1.TableEvents.captureLastAction(this));
    }
    nextBoardAction() {
        this.board.nextAction();
        this.updatePlayingPlayers();
    }
    getCheckpoint() {
        return super.lastCheckpoint();
    }
    getCurrentCheckpoint() {
        return super.currentCheckpoint();
    }
    activePlayers() {
        return this.players.filter((p) => p.isInPlay() || p.isAllIn());
    }
    gamePlayers() {
        return this.players.filter((p) => p.isInPlay() || p.isAllIn() || p.isSittingOut());
    }
    playingPlayers() {
        return this.players.filter((p) => p.isInPlay() || p.isAllIn() || p.isFolded());
    }
    foreverOutPlayers() {
        return this.players.filter((p) => p.isForeverOut());
    }
    inPlayPlayers() {
        return this.players.filter((p) => p.isInPlay());
    }
    observerPlayers() {
        return this.players.filter((p) => p.isObserver());
    }
    playersWithBets() {
        return this.players.filter((p) => p.bet > 0);
    }
    allInPlayers() {
        return this.players.filter((p) => p.isAllIn());
    }
    allPlayersAreAllIn() {
        return this.allInPlayers().length >= this.activePlayers().length;
    }
    foldedPlayers() {
        return this.players.filter((p) => p.isFolded());
    }
    oneActivePlayerLeft() {
        return (this.activePlayers().length === 1 || this.inPlayPlayers().length === 1);
    }
    outPlayers() {
        return this.players.filter((p) => p.chips <= 0);
    }
    countFromButton(times) {
        if (this.allPlayersAreAllIn()) {
            return this.button;
        }
        else {
            return this.countToNextInPlayPlayer(this.getButtonPlayer().getId(), times);
        }
    }
    countToNextInPlayPlayer(fromPlayerId, times) {
        let position = this.getPlayerIndexByPlayerId(fromPlayerId);
        while (times > 0) {
            position = (position + 1) % this.players.length;
            if (this.players[position] &&
                (this.players[position].isInPlay() ||
                    this.players[position].isAllIn() ||
                    this.players[position].isFolded())) {
                times = times - 1;
            }
        }
        return position;
    }
    getPlayerByName(playerName) {
        return this.players.find((p) => p.name === playerName);
    }
    getPlayerById(playerId) {
        return this.players.find((p) => p.getId() === playerId);
    }
    getPlayerByUserId(userId) {
        return this.players.find((p) => p.userId === userId);
    }
    getPlayerIndexByPlayerId(playerId) {
        return this.players
            .filter((p) => p)
            .findIndex((p) => p.getId() === playerId);
    }
    getButtonPlayer() {
        return this.players[this.getButtonPlayerIndex()];
    }
    getButtonPlayerIndex() {
        return this.button > 0 ? this.button : 0;
    }
    getCurrentPlayer() {
        return this.players[this.getCurrentPlayerIndex()];
    }
    getCurrentPlayerIndex() {
        return this.currentPlayer;
    }
    getSmallBlindPlayer() {
        if (this.smallBlindLeft) {
            return undefined;
        }
        return this.players.find((p) => p.role === 'SB');
    }
    getSmallBlindPlayerIndex() {
        return this.isHeadsUpPlay()
            ? this.getButtonPlayerIndex()
            : this.countFromButton(1);
    }
    getBigBlindPlayer() {
        if (this.bigBlindLeft) {
            return undefined;
        }
        return this.players.find((p) => p.role === 'BB');
    }
    getBigBlindPlayerIndex() {
        return this.isHeadsUpPlay()
            ? this.countFromButton(1)
            : this.countFromButton(2);
    }
    getWaitlist() {
        return this.players.filter((p) => p.isWaiting());
    }
    getWaitlistPlayerById(playerId) {
        return this.getWaitlist().find((p) => p.getId() === playerId);
    }
    getWaitlistPlayerByUserId(userId) {
        return this.getWaitlist().find((p) => p.userId === userId);
    }
    getWaitlistPlayerIndex(playerId) {
        return this.getWaitlist().findIndex((p) => p.getId() === playerId);
    }
    getSitoutList() {
        return this.players.filter((p) => p.isSittingOut());
    }
    getSitoutPlayerById(playerId) {
        return this.getSitoutList().find((p) => p.getId() === playerId);
    }
    getSitoutPlayerIndex(playerId) {
        return this.getSitoutList().findIndex((p) => p.getId() === playerId);
    }
    getSitoutPlayerByUserId(userId) {
        return this.getSitoutList().find((p) => p.userId === userId);
    }
    totalPlayers() {
        return this.players.length;
    }
    isCurrentPlayer(playerId) {
        var _a;
        return ((_a = this.getCurrentPlayer()) === null || _a === void 0 ? void 0 : _a.getId()) === playerId;
    }
    isPlayerTurn(playerId) {
        if (!this.isCurrentPlayer(playerId) || GameState_1.GameStates.isPaused(this.state)) {
            throw new PlayOutOfTurnError_1.PlayOutOfTurnError(this.getPlayerById(playerId).name);
        }
        return true;
    }
    doBetForPlayer(playerId, bet) {
        this.isPlayerTurn(playerId);
        this.update(TableEvent_1.TableEvents.playerBetEvent(this, this.getPlayerById(playerId), bet));
        this.nextTurn();
    }
    doCallForPlayer(playerId) {
        this.isPlayerTurn(playerId);
        this.update(TableEvent_1.TableEvents.playerCalledEvent(this, this.getPlayerById(playerId)));
    }
    doAllInForPlayer(playerId) {
        this.isPlayerTurn(playerId);
        const player = this.getPlayerById(playerId);
        player.goAllIn();
        this.doBetForPlayer(playerId, new Bet_1.Bet(player.chips + player.bet, Bet_1.BetKind.BET));
    }
    doBuyInForPlayer(playerId, chips) {
        const player = this.getPlayerById(playerId);
        if (player) {
            player.buyChips(chips);
            this.update(TableEvent_1.TableEvents.playerBuyInEvent(this, player));
        }
    }
    doCheckForPlayer(playerId) {
        this.isPlayerTurn(playerId);
        this.update(TableEvent_1.TableEvents.playerCheckedEvent(this, this.getPlayerById(playerId)));
        this.nextTurn();
    }
    doFoldForPlayer(playerId) {
        var _a, _b;
        Logger_1.logger.trace(`doFoldForPlayer.playerId: ${playerId}`);
        this.isPlayerTurn(playerId);
        const player = this.getPlayerById(playerId);
        if (((_a = this.getBigBlindPlayer()) === null || _a === void 0 ? void 0 : _a.getId()) === player.getId()) {
            this.bigBlindFold = true;
        }
        if (((_b = this.getSmallBlindPlayer()) === null || _b === void 0 ? void 0 : _b.getId()) === player.getId()) {
            this.smallBlindFold = true;
        }
        player.fold();
        this.update(TableEvent_1.TableEvents.playerFoldedEvent(this, player));
        this.nextTurn();
    }
    doPostBlindForPlayer(playerId, bet) {
        this.update(TableEvent_1.TableEvents.playerPostedBlind(this, this.getPlayerById(playerId), bet));
    }
    payBlinds() {
        if (this.board.isPreDeal() && this.getSmallBlindPlayer()) {
            this.doPostBlindForPlayer(this.getSmallBlindPlayer().getId(), new Bet_1.Bet(this.blinds.small, Bet_1.BetKind.SMALLBLIND));
            this.doPostBlindForPlayer(this.getBigBlindPlayer().getId(), new Bet_1.Bet(this.blinds.big, Bet_1.BetKind.BIGBLIND));
        }
        else {
            throw new TriedToPlayBlindsOutOfOrderError_1.TriedToPlayBlindsOutOfOrderError();
        }
    }
    removeOutPlayers() {
        this.update(TableEvent_1.TableEvents.playerOutEvent(this));
    }
    removeForeverOutPlayers() {
        Logger_1.logger.trace('removeForeverOutPlayers called');
        const foreverOutPlayers = this.foreverOutPlayers();
        foreverOutPlayers.map((op) => {
            op.resetPlayer();
            this.update(TableEvent_1.TableEvents.playerForeverOutEvent(this, op));
        });
    }
    resetInactivePlayers() {
        this.update(TableEvent_1.TableEvents.playerResetEvent(this));
    }
    enableAutoStart() {
        this.autostart = true;
        this.update(TableEvent_1.TableEvents.autoStartEvent(this));
    }
    disableAutoStart() {
        this.autostart = false;
        this.update(TableEvent_1.TableEvents.autoStartEvent(this));
    }
    resetIfNotEnoughPlayers() {
        if (this.activePlayers().length < this.minPlayers) {
            this.reset();
            return true;
        }
        return false;
    }
    reset() {
        this.playingPlayers().map((player) => {
            player.chips += player.bet;
            player.resetBets();
            player.resetPlayer();
            this.waitlistPlayer(player);
        });
        this.buttonPlayerId = '';
        this.state = GameStateReducer_1.GameReducer(GameStateAction_1.GameActions.ResetPlay, this.state);
        this.update(TableEvent_1.TableEvents.tableResetEvent(this));
    }
    softReset() {
        this.playingPlayers().map((player) => {
            player.chips += player.bet;
            player.resetBets();
            player.resetPlayer();
        });
        this.state = GameStateReducer_1.GameReducer(GameStateAction_1.GameActions.ResetPlay, this.state);
        this.update(TableEvent_1.TableEvents.tableResetEvent(this));
    }
    updatePlayersFromWaitlist() {
        const waitlist = this.getWaitlist();
        while (waitlist.length > 0 &&
            this.playingPlayers().length < this.maxPlayers) {
            const playerId = waitlist.pop().getId();
            const player = this.getPlayerById(playerId);
            const playerIndex = this.getPlayerIndexByPlayerId(playerId);
            this.players.splice(playerIndex, 1);
            this.players.splice(this.getButtonPlayerIndex(), 0, player);
            player.beginPlay();
            this.update(TableEvent_1.TableEvents.playerJoinedEvent(this, player));
        }
    }
    updateHandStrengths() {
        this.updateHandStrengthsForPlayers(this.playingPlayers());
    }
    updateHandStrengthsForPlayers(players) {
        try {
            players.map((player) => {
                player.setRankedHand(this.board.communityCards);
            });
            this.update(TableEvent_1.TableEvents.rankedHandEvent(this));
        }
        catch (err) {
            Logger_1.logger.debug(err);
            Logger_1.logger.debug(this.board.communityCards);
            players.map((player) => {
                Logger_1.logger.debug(player.showCards());
            });
        }
        return players;
    }
    updatePlayerActions() {
        this.playingPlayers().map((player) => player.setActions(ActionEvaluator_1.ActionEvaluator.getActionHints(this.board, player, this.getBigBlindPlayer())));
    }
    updatePlayingPlayers() {
        this.updateHandStrengths();
        this.updatePlayerActions();
        this.update(TableEvent_1.TableEvents.playerEndOfTurn(this));
    }
    doShowdown() {
        Logger_1.logger.trace('Doing Showdown');
        this.stackThePots();
        if (!this.checkEveryoneFolded()) {
            this.update(TableEvent_1.TableEvents.handShowdownEvent(this));
        }
        else {
            this.update(TableEvent_1.TableEvents.handEveryoneFolded(this));
        }
        this.update(TableEvent_1.TableEvents.handWinnersEvent(this));
    }
    stackThePots() {
        if (!this.board.isShowdown() && this.inPlayPlayers().length > 1) {
            throw new CannotStackPotsBeforeShowdown_1.CannotStackPotsBeforeShowdown();
        }
        else if (this.checkEveryoneFolded()) {
            const player = this.activePlayers()[0];
            this.board.getAllPots().map((pot) => {
                player.chips += pot.amount;
                pot.setWinners([this.createEmptyPotWinner(player, pot)]);
            });
        }
        else {
            this.board.getAllPots().map((pot) => {
                var _a;
                const potWinners = [];
                const activePlayerIds = this.activePlayers().map((player) => player.getId());
                let players = pot.players.length > 0 ? pot.players : this.activePlayers();
                players = players.filter((player) => activePlayerIds.includes(player.getId()));
                if (players.length === 1) {
                    let chips = (_a = players[0].chips) !== null && _a !== void 0 ? _a : 0;
                    chips += pot.amount;
                    potWinners.push(this.createPotWinner(players[0], pot.amount, pot.kind));
                }
                else {
                    players = this.updateHandStrengthsForPlayers(players);
                    const winningHands = pokersolver_1.Hand.winners([
                        ...players
                            .filter((player) => player && player.rankedHand)
                            .map((player) => player.rankedHand),
                    ]);
                    const payout = this.getPayout(pot.amount, winningHands);
                    winningHands.map((hand) => {
                        const player = this.getPlayerById(hand.playerId);
                        let totalPayout = payout[0];
                        if (hand.playerId === payout[1]) {
                            totalPayout += payout[2];
                        }
                        const tablePlayer = this.getPlayerById(player.getId());
                        tablePlayer.chips += totalPayout;
                        Logger_1.logger.info(`${tablePlayer.name} won ${totalPayout} chips from ${pot.kind}`);
                        potWinners.push(this.createPotWinner(tablePlayer, totalPayout, pot.kind));
                    });
                }
                pot.setWinners(potWinners);
            });
        }
    }
    createPotWinner(player, totalPayout, potKind) {
        if (player && (player.isAllIn() || player.isInPlay())) {
            return new Pot_1.PotWinner(player.getId(), player.name, player.showCards(), totalPayout, potKind, player.rankedHand.name, player.rankedHand.descr, player.rankedHand.cards, player.userId);
        }
        throw new Error('could not create pot winner error');
    }
    createEmptyPotWinner(player, pot) {
        if (player && (player.isInPlay() || player.isAllIn())) {
            return new Pot_1.PotWinner(player.getId(), player.name, [], pot.amount, pot.kind, player.rankedHandName, player.rankedHandDescription, [], player.userId);
        }
        throw new Error('could not create pot winner error');
    }
    getPayout(potAmount, winningHands) {
        const payout = potAmount / winningHands.length;
        if (Number.isInteger(payout)) {
            return [payout, '', 0];
        }
        else {
            const buttonPlayerSeat = this.getButtonPlayerIndex();
            const closestToButton = winningHands.reduce((acc, hand) => {
                const playerSeat = this.getPlayerIndexByPlayerId(hand.playerId);
                const seatDiff = playerSeat - buttonPlayerSeat;
                if (acc && seatDiff < acc[0]) {
                    return [seatDiff, hand.playerId];
                }
                else {
                    return acc;
                }
            }, [0, '']);
            return [Math.floor(payout), closestToButton[1], 1];
        }
    }
    captureBets() {
        this.adjustBetForBigBlind();
        if (this.allInPlayers().length === 0) {
            this.board.addBetsToPot();
        }
        else {
            const allInBetting = this.checkBettingWithAllIn();
            if (!allInBetting) {
                if (this.activePlayers().length === 2) {
                    this.board.addBetsToPot();
                }
                else {
                    this.board.addBetsToMainPot(new Pot_1.Pot(0, this.activePlayers(), Pot_1.PotKind.MAIN));
                }
            }
            else {
                if (this.activePlayers().length === 2 &&
                    this.board.sidePots.length === 0) {
                    this.board.addBetsToPot(new Pot_1.Pot(0, this.activePlayers(), Pot_1.PotKind.MAIN));
                }
                else {
                    let i = 0;
                    while (this.board.hasNonZeroBets() &&
                        i < this.activePlayers().length) {
                        const smallestBet = this.getSmallestBet();
                        const sidePot = this.activePlayers()
                            .filter((player) => player.bet > 0)
                            .reduce((pot, player) => {
                            const playerSeat = this.getPlayerIndexByPlayerId(player.getId());
                            this.board.adjustBetForPlayerAt(playerSeat, smallestBet);
                            player.bet -= smallestBet;
                            pot.amount += smallestBet;
                            pot.players.push(player);
                            return pot;
                        }, new Pot_1.Pot(0, [], Pot_1.PotKind.SIDE));
                        if (sidePot.players.length === 1) {
                            const player = this.getPlayerById(sidePot.players[0].getId());
                            player.chips += sidePot.amount;
                            player.bet = 0;
                            const playerSeat = this.getPlayerIndexByPlayerId(player.getId());
                            this.board.adjustBetForPlayerAt(playerSeat, 0);
                        }
                        else {
                            if (sidePot.amount !== 0 || sidePot.players.length !== 0) {
                                if (sidePot.players.length === this.activePlayers().length) {
                                    sidePot.kind = Pot_1.PotKind.MAIN;
                                    this.board.addPot(sidePot);
                                }
                                else {
                                    this.board.addPot(sidePot);
                                }
                            }
                        }
                        i++;
                    }
                    this.board.clearBets();
                }
            }
        }
        this.playingPlayers().map((p) => p.resetBets());
    }
    adjustBetForBigBlind() {
        if (this.getBigBlindPlayer()) {
            const playerseat = this.getPlayerIndexByPlayerId(this.getBigBlindPlayer().getId());
            const updateBet = this.getBigBlindPlayer().bet;
            this.board.adjustBetForBigBlind(playerseat, updateBet);
        }
    }
    getSmallestBet() {
        if (this.getSmallBlindPlayer().isFolded() &&
            this.getBigBlindPlayer().isFolded()) {
            return this.board.smallestBetWithoutSBandBB();
        }
        else if (this.getSmallBlindPlayer().isFolded()) {
            return this.board.smallestBetWithoutSB();
        }
        else if (this.getBigBlindPlayer().isFolded()) {
            return this.board.smallestBetWithoutBB();
        }
        else {
            return this.board.smallestBet();
        }
    }
    checkBettingWithAllIn() {
        const unequalBets = this.activePlayers().reduce((acc, player) => {
            if (!acc) {
                acc = player.bet != this.board.biggestBet();
            }
            return acc;
        }, false);
        if (this.allPlayersAreAllIn() && unequalBets) {
            return true;
        }
        for (var i = 0; i < this.activePlayers().length; i++) {
            if (this.activePlayers()[i].bets.length === 0) {
                return true;
            }
        }
        const biggestBet = this.board.biggestBet();
        const biggestAllIn = this.allInPlayers().reduce((acc, allInPlayer) => {
            if (allInPlayer.bet > acc) {
                acc = allInPlayer.bet;
            }
            return acc;
        }, 0);
        const betDiff = biggestBet - biggestAllIn;
        if (betDiff > 0) {
            return true;
        }
        return false;
    }
    playersHaveFinishedBetting() {
        const biggestBet = this.board.biggestBet();
        const stillBetting = this.activePlayers().reduce((acc, player) => {
            if (player.isAllIn()) {
                return acc;
            }
            let bet = this.board.getBetForPlayerAt(this.getPlayerIndexByPlayerId(player.getId()));
            if (bet && (bet.amount !== biggestBet || bet.kind === Bet_1.BetKind.BIGBLIND)) {
                return acc + 1;
            }
            else if (!bet) {
                return acc + 1;
            }
            return acc;
        }, 0);
        Logger_1.logger.trace('Finished Betting' + (stillBetting === 0));
        return stillBetting === 0;
    }
    getBetHints() {
        return BettingRecommender_1.BettingRecommender.getBetHints(this.board);
    }
    checkEveryoneFolded() {
        if (this.foldedPlayers().length === this.playingPlayers().length - 1) {
            return true;
        }
        return false;
    }
    isHeadsUpPlay() {
        return this.playingPlayers().length === 2;
    }
    isPaused() {
        return GameState_1.GameStates.isPaused(this.state);
    }
    isPlaying() {
        return GameState_1.GameStates.isPlaying(this.state);
    }
    isReadyToPlay() {
        return GameState_1.GameStates.isReadyToPlay(this.state);
    }
    isReset() {
        return GameState_1.GameStates.isReset(this.state);
    }
    isFinished() {
        return GameState_1.GameStates.isFinished(this.state);
    }
    isDefault() {
        return GameMode_1.GameModes.isDefault(this.mode);
    }
    onPokerTableCreated(event) {
        Logger_1.logger.trace('OnPokerTableCreated called');
        const table = event.snapshot.table[0];
        this.name = table.name;
        this.minPlayers = table.minPlayers;
        this.maxPlayers = table.maxPlayers;
        this.bigBlind = table.bigBlindAmount;
        this.button = table.buttonPlayer;
        this.currentPlayer = table.currentPlayer;
        this.setId(table.id);
        this.state = GameState_1.GameStates.ReadyToPlay;
        this.blinds = new Blind_1.Blind(this.bigBlind);
        this.board = new Board_1.Board(this.blinds);
    }
    onPokerTableStarted() {
        Logger_1.logger.trace('OnPokerTableStarted called');
        this.state = GameStateReducer_1.GameReducer(GameStateAction_1.GameActions.StartPlay, this.state);
    }
    onPokerTablePaused() {
        Logger_1.logger.trace('OnPokerTablePaused called');
        this.state = GameStateReducer_1.GameReducer(GameStateAction_1.GameActions.PausePlay, this.state);
    }
    onPokerTableReset() {
        Logger_1.logger.trace('OnPokerTableReset called');
        this.state = GameStateReducer_1.GameReducer(GameStateAction_1.GameActions.ResetPlay, this.state);
    }
    onPokerTableFinished() {
        Logger_1.logger.trace('OnPokerTableFinished called');
        this.state = GameStateReducer_1.GameReducer(GameStateAction_1.GameActions.EndGame, this.state);
    }
    onPokerTableHandNew() {
        Logger_1.logger.trace('OnPokerTableHandNew called');
        this.bigBlindFold = false;
        this.bigBlindLeft = false;
        this.smallBlindFold = false;
        this.smallBlindLeft = false;
        this.minimumRaise = config.DEFAULT_BIG_BLIND;
        if (GameMode_1.GameModes.isTournament(this.mode)) {
            this.minimumRaise = this.blinds.big;
            this.minimumBet = this.blinds.big;
        }
        else {
            this.minimumRaise = config.DEFAULT_BIG_BLIND;
        }
        if (this.blinds.big === 0) {
            this.blinds = new Blind_1.Blind(config.DEFAULT_BIG_BLIND);
        }
        this.removeOutPlayers();
        this.foreverOutPlayers();
        this.resetInactivePlayers();
        this.updatePlayersFromWaitlist();
        this.updatePlayersSeat();
        this.collectCards();
        if (this.resetIfNotEnoughPlayers()) {
            return;
        }
        this.board.setupNewHand(this.blinds);
        this.board.setPlayers(this.activePlayers());
        this.setTheButton();
        this.activePlayers().map((p) => p.resetBets());
        this.payBlinds();
        this.board.nextAction();
        this.dealCards();
        this.updatePlayingPlayers();
        this.update(TableEvent_1.TableEvents.tableStartedEvent(this));
    }
    updatePlayersSeat() {
        this.players.map((player) => {
            const seatId = this.getPlayerIndexByPlayerId(player.getId());
            this.board.addPlayerBettingSeatAt(seatId);
            player.setSeatId(seatId);
        });
    }
    onPokerTableHandCurrent_player(event) {
        Logger_1.logger.trace('OnPokerTableHandCurrent_player called');
        if (event.snapshot.forPlayer) {
            const eventCurrentPlayerId = event.snapshot.forPlayer.id;
            if (this.getCurrentPlayer().getId() !== eventCurrentPlayerId) {
                this.currentPlayer = this.getPlayerIndexByPlayerId(eventCurrentPlayerId);
                this.currentPlayerId = eventCurrentPlayerId;
            }
        }
        this.updatePlayingPlayers();
    }
    onPokerTableHighestBet_player(event) {
        Logger_1.logger.trace('onPokerTableHighestBet_player called');
    }
    onPokerTableHandDealt(event) {
        Logger_1.logger.trace('OnPokerTableHandDealt called');
        Object.keys(event.snapshot.players).map((key) => {
            const eventPlayer = event.snapshot.players[key];
            const player = this.getPlayerById(eventPlayer.id);
            if (JSON.stringify(player.showCards()) !== JSON.stringify(eventPlayer.cards)) {
                player.returnCards();
                player.getCards(eventPlayer.cards);
            }
        });
    }
    onPokerTablePlayerJoined(event) {
        Logger_1.logger.trace('onPokerTablePlayerJoined called');
        const newPlayer = this.getPlayerById(event.snapshot.forPlayer.id);
        if (!newPlayer) {
            this.players.splice(this.getButtonPlayerIndex(), 0, newPlayer);
            this.board.addPlayerBettingSeatAt(this.getButtonPlayerIndex());
            this.adjustTheButton();
        }
        else {
            newPlayer.beginPlay();
        }
        if (this.autostart &&
            GameState_1.GameStates.isReset(this.state) &&
            this.activePlayers().length >= this.minPlayers) {
            Logger_1.logger.trace('onPokerTablePlayerJoined - calling new hand');
            this.state = GameStateReducer_1.GameReducer(GameStateAction_1.GameActions.StartPlay, this.state);
            this.newHand();
        }
    }
    onPokerTablePlayerWaitlisted(event) {
        Logger_1.logger.trace('onPokerTablePlayerWaitlisted called');
        if (!this.getPlayerById(event.snapshot.forPlayer.id)) {
            this.players.splice(this.getButtonPlayerIndex(), 0, event.snapshot.forPlayer);
        }
    }
    onPokerTablePlayerOut() {
        Logger_1.logger.trace('onPokerTablePlayerOut called');
        const outPlayers = this.outPlayers();
        outPlayers.map((op) => {
            op.resetPlayer();
            op.sitOut();
            if (op.buyIn) {
                this.update(TableEvent_1.TableEvents.playerOutOfChipsEvent(this, op));
            }
        });
    }
    onPokerTablePlayerForeverout() {
        Logger_1.logger.trace('onPokerTablePlayerForeverout called');
    }
    onPokerTablePlayerOutofchips() {
        Logger_1.logger.trace('onPokerTablePlayerOutOfChips called');
    }
    onPokerTablePlayerLeft() {
        Logger_1.logger.trace('onPokerTablePlayerLeft called');
    }
    onPokerTablePlayerDisconnected() {
        Logger_1.logger.trace('onPokerTablePlayerDisconnected called');
    }
    onPokerTablePlayerObserver() {
        Logger_1.logger.trace('onPokerTablePlayerObserver called');
    }
    onPokerTablePlayerBet(event) {
        Logger_1.logger.trace('onPokerTablePlayerBet called');
        const player = this.getPlayerById(event.snapshot.forPlayer.id);
        const playerSeat = this.getPlayerIndexByPlayerId(player.getId());
        const bet = event.snapshot.withBet;
        if (typeof bet === 'undefined') {
            throw new BetUndefinedForPlayer_1.BetUndefinedForPlayer();
        }
        if (bet.kind !== Bet_1.BetKind.CALL &&
            bet.kind === Bet_1.BetKind.BET &&
            bet.amount < this.minimumRaise &&
            !player.isAllIn()) {
            if (player.chips < this.minimumRaise) {
                player.goAllIn();
            }
            else if (this.board.biggestBet() > 0 &&
                bet.amount < this.board.biggestBet()) {
                throw new Error(`Player cannot bet less than ${this.board.biggestBet()}`);
            }
            else {
                throw new Error(`Player cannot bet less than ${this.minimumRaise}`);
            }
        }
        if (bet.kind !== Bet_1.BetKind.CALL &&
            bet.kind !== Bet_1.BetKind.CHECK &&
            this.board.biggestBet() > 0 &&
            bet.amount === this.board.biggestBet()) {
            bet.kind = Bet_1.BetKind.CALL;
        }
        else {
            if (this.isPreFlop()) {
                if (bet.kind === Bet_1.BetKind.RAISE && bet.amount < this.getMinimumRaise()) {
                    throw new Error(`Player cannot raise less than ${this.getMinimumRaise()}`);
                }
                else if (bet.kind === Bet_1.BetKind.RAISE || bet.kind === Bet_1.BetKind.BET) {
                    this.minimumRaise =
                        this.board.biggestBet() > 0
                            ? bet.amount - this.board.biggestBet()
                            : bet.amount - this.minimumRaise;
                }
            }
            else {
                if (bet.kind === Bet_1.BetKind.RAISE && bet.amount < this.getMinimumRaise()) {
                    throw new Error(`Player cannot raise less than ${this.getMinimumRaise()}`);
                }
            }
        }
        if ([Bet_1.BetKind.BET].includes(bet.kind)) {
            if (this.board.biggestBet() > 0 &&
                bet.amount > this.board.biggestBet() &&
                !player.isAllIn()) {
                bet.kind = Bet_1.BetKind.RAISE;
            }
        }
        const playerBet = this.board.getBetForPlayerAt(playerSeat);
        if (playerBet) {
            bet.amount -= playerBet.amount;
        }
        player.payBet(bet);
        if (player.chips <= 0) {
            player.goAllIn();
            this.update(TableEvent_1.TableEvents.playerAllInEvent(this, player));
        }
        this.board.doBetForPlayerAt(playerSeat, new Bet_1.Bet(player.bet, bet.kind));
    }
    getMinimumRaise() {
        if (this.isPreFlop()) {
            return this.board.biggestBet() > 0
                ? this.board.biggestBet() + this.minimumRaise
                : this.minimumRaise * 2;
        }
        else {
            if (this.board.secondBiggestBet() === 0) {
                return this.board.biggestBet() * 2;
            }
            return (this.board.biggestBet() -
                this.board.secondBiggestBet() +
                this.board.biggestBet());
        }
    }
    isPreFlop() {
        return !this.board.isFlop() && !this.board.isTurn() && !this.board.isRiver();
    }
    onPokerTablePlayerAllin(event) {
        Logger_1.logger.trace('onPokerTablePlayerAllin called');
        const player = this.getPlayerById(event.snapshot.forPlayer.id);
        player.goAllIn();
    }
    onPokerTablePlayerChecked(event) {
        Logger_1.logger.trace('onPokerTablePlayerChecked called');
        const player = this.getPlayerById(event.snapshot.forPlayer.id);
        this.board.doCheckForPlayerAt(this.getPlayerIndexByPlayerId(player.getId()));
        player.payBet(new Bet_1.Bet(0, Bet_1.BetKind.CHECK));
    }
    onPokerTablePlayerCalled(event) {
        Logger_1.logger.trace('onPokerTablePlayerCalled called');
        const playerId = event.snapshot.forPlayer.id;
        const playerSeat = this.getPlayerIndexByPlayerId(playerId);
        const biggestBet = this.board.biggestBet();
        let playerBet = this.board.getBetForPlayerAt(playerSeat);
        if (!playerBet) {
            playerBet = new Bet_1.Bet(0, Bet_1.BetKind.BET);
        }
        if (biggestBet == 0) {
            throw new CantCallNoBetError_1.CantCallNoBetError();
        }
        const player = this.getPlayerById(playerId);
        let newBet = biggestBet;
        if (newBet >= player.chips + player.bet) {
            newBet = player.chips;
        }
        this.doBetForPlayer(playerId, new Bet_1.Bet(newBet, Bet_1.BetKind.CALL));
    }
    onPokerTablePlayerFolded(event) {
        Logger_1.logger.trace('onPokerTablePlayerFolded called');
        const player = this.getPlayerById(event.snapshot.forPlayer.id);
        if (!player.isFolded()) {
            const seatId = this.getPlayerIndexByPlayerId(player.getId());
            const foldedBet = this.board.getBetForPlayerAt(seatId);
            if (foldedBet) {
                this.board.pot.amount += foldedBet.amount;
                this.board.doBetForPlayerAt(seatId, undefined);
            }
            player.fold();
        }
    }
    onPokerTablePlayerPost_blind(event) {
        Logger_1.logger.trace('onPokerTablePlayerPost_blind called');
        const playerId = event.snapshot.forPlayer.id;
        const player = this.getPlayerById(playerId);
        const playerSeat = this.getPlayerIndexByPlayerId(playerId);
        const bet = event.snapshot.withBet;
        player.payBet(bet);
        if (player.chips <= 0) {
            player.goAllIn();
        }
        this.board.doBetForPlayerAt(playerSeat, bet);
    }
    onPokerTablePlayerReset(event) {
        Logger_1.logger.trace('onPokerTablePlayerReset called');
        this.players
            .filter((p) => p.isFolded() || p.isAllIn())
            .map((p) => p.beginPlay());
    }
    onPokerTablePlayerBuyin(event) {
        Logger_1.logger.trace('onPokerTablePlayerBuyIn called');
        const player = this.getPlayerById(event.snapshot.forPlayer.id);
        player.playerOutTime = 0;
        if (player === null || player === void 0 ? void 0 : player.isSittingOut()) {
            const sitoutPlayer = this.getSitoutPlayerById(player.getId());
            sitoutPlayer.chips = player.chips;
            this.waitlistPlayer(player);
        }
        else if (player === null || player === void 0 ? void 0 : player.isInPlay()) {
            const playerInPlay = this.getPlayerById(player.getId());
            playerInPlay.chips = player.chips;
        }
    }
    onPokerTablePlayerDoNoActionForPlayerEvent(event) {
        Logger_1.logger.trace('onPokerTablePlayerDoNoActionForPlayerEvent called');
    }
    onPokerTableHandShowdown(event) {
        Logger_1.logger.trace('onPokerTableHandShowdown called');
    }
    onPokerTableHandWinners(event) {
        Logger_1.logger.trace('onPokerTableHandWinners called');
        this.board.nextAction();
    }
    onPokerTableHandAll_players_allin(event) {
        Logger_1.logger.trace('onPokerTableHandAllPlayersAllIn');
    }
    onPokerTableHandEveryone_folded(event) {
        Logger_1.logger.trace('onPokerTableHandEveryone_folded');
    }
    onPokerTableStreetFinished(event) {
        Logger_1.logger.trace('onPokerTableStreetFinished');
        const currentPlayer = this.getCurrentPlayer();
        this.lastPlayerAction = currentPlayer.state.tag;
    }
    onPokerTablePlayerSitout(event) {
        Logger_1.logger.trace('onPokerTablePlayerSitout called');
    }
    onPokerTablePlayerShowCardsForTeacherEvent(event) {
        Logger_1.logger.trace('onPokerTablePlayerShowCardsForTeacherEvent called');
    }
    onPokerTablePlayerHideCardsForTeacherEvent(event) {
        Logger_1.logger.trace('onPokerTablePlayerShowCardsForTeacherEvent called');
    }
    onPokerTablePlayerCaptureLastAction(event) {
        Logger_1.logger.trace('onPokerTablePlayerCaptureLastAction called');
        const currentPlayer = this.getCurrentPlayer();
        const playerSeat = this.getPlayerIndexByPlayerId(currentPlayer.getId());
        const currentLastBet = this.board.getBetForPlayerAt(playerSeat);
        this.lastBet = currentLastBet
            ? new Bet_1.Bet(currentPlayer.bet, currentLastBet.kind)
            : undefined;
        this.lastPlayerAction = currentPlayer.state.tag;
    }
    onPokerTableAutoStart(event) {
        Logger_1.logger.trace('onPokerTableAutoStart called');
    }
    onPokerTablePlayerRankedHandEvent(event) {
        Logger_1.logger.trace('onPokerTablePlayerRankedHandEvent called');
    }
    onPokerTableCalculateNextBlindEvent(event) {
        Logger_1.logger.trace('onPokerTableCalculateNextBlindEvent called');
    }
    onPokerTableTournamentBlindEvent(event) {
        Logger_1.logger.trace('onPokerTableTournamentBlindEvent called');
    }
    onPokerTablePlayerEndofturn() {
        Logger_1.logger.trace('onPokerTablePlayerEndofturn called');
    }
    onPokerTablePlayerRemovedByTeacherEvent() {
        Logger_1.logger.trace('onPokerTablePlayerRemovedByTeacherEvent called');
    }
    onPokerTablePlayerBuyInEvent() {
        Logger_1.logger.trace('onPokerTablePlayerBuyInEvent called');
    }
    update(event) {
        this.updateState(event);
        this.event$.next(event);
    }
    getId() {
        return super.getId();
    }
    getVersion() {
        return super.getVersion();
    }
    getEvents() {
        return super.getEvents();
    }
    internalState() {
        return this.state;
    }
    getDisconnectedList() {
        return this.players.filter((p) => p.isDisconnected());
    }
    doLeaveGameForPlayer(playerId) {
        var _a, _b;
        Logger_1.logger.trace('doLeaveGameForPlayer', playerId);
        const player = this.getPlayerById(playerId);
        if (player) {
            if (((_a = this.getBigBlindPlayer()) === null || _a === void 0 ? void 0 : _a.getId()) === player.getId()) {
                this.bigBlindLeft = true;
            }
            if (((_b = this.getSmallBlindPlayer()) === null || _b === void 0 ? void 0 : _b.getId()) === player.getId()) {
                this.smallBlindLeft = true;
            }
            if (this.isCurrentPlayer(playerId)) {
                this.doFoldForPlayer(playerId);
            }
            else {
                player.returnCards();
            }
            this.doDisconnectForPlayer(playerId);
            this.players.splice(this.players.indexOf(player), 1);
            this.leftPlayers.push(player);
            if (player.isTeachingObserver()) {
                const observers = this.observerPlayers();
                if (observers.length > 0) {
                    observers[0].observerId = 1;
                }
            }
            this.resetPlayerSeats();
            this.board.getAllPots().map((pot) => {
                pot.players = pot.players.filter((player) => player.getId() !== playerId);
            });
            this.adjustTheButton();
            const tableReset = this.resetIfNotEnoughPlayers();
            if (!tableReset &&
                this.players.length >= 2 &&
                this.isCurrentPlayer(playerId)) {
                this.nextPlayer();
            }
            this.update(TableEvent_1.TableEvents.playerLeftEvent(this));
        }
    }
    doDisconnectForPlayer(playerId) {
        Logger_1.logger.trace('doDisconnectForPlayer', playerId);
        const player = this.getPlayerById(playerId);
        if (player) {
            player.disconnect();
            this.update(TableEvent_1.TableEvents.disconnected(this, player));
        }
    }
    playerIsDisconnected(player) {
        Logger_1.logger.trace('checkDisconnectedPlayer-player.getId', player.getId());
        return this.getDisconnectedList().find((p) => p.getId() === player.getId());
    }
    doNoActionForPlayer(forPlayerId, fromMyPlayerId, lock) {
        try {
            Logger_1.logger.trace('doNoActionForPlayer');
            Logger_1.logger.info(forPlayerId, 'fromMyPlayerId', fromMyPlayerId);
            if (!lock && GameState_1.GameStates.isPaused(this.state)) {
                Logger_1.logger.debug('ignoring doNoActionForPlayer, game is paused');
            }
            else if (!lock) {
                const player = this.getPlayerById(forPlayerId);
                if (forPlayerId === this.getCurrentPlayer().getId()) {
                    player.doNoActionCount++;
                    if (player.doNoActionCount === 2) {
                        player.wait();
                        this.update(TableEvent_1.TableEvents.playerWaitlistedEvent(this, player));
                        player.doNoActionCount = 0;
                        this.nextTurn();
                    }
                    else {
                        if (player && player.canCheck()) {
                            Logger_1.logger.trace('checking for player');
                            this.doCheckForPlayer(player.getId());
                        }
                        else if (player && player.canFold()) {
                            Logger_1.logger.trace('folding for player');
                            this.doFoldForPlayer(player.getId());
                        }
                    }
                }
                else {
                    Logger_1.logger.debug("doNoActionForPlayer, no longer current player's turn, maybe the client is out-of-sync client, so no-op");
                    Logger_1.logger.debug('' + __1.Timing.getUtcMsNow());
                    Logger_1.logger.debug('' + super.lastCheckpoint());
                }
            }
        }
        catch (error) {
            console.error('doNoActionForPlayer', error);
        }
        finally {
            this.update(TableEvent_1.TableEvents.createEvent(TableEvent_1.TableEventKind.DoNoActionForPlayerEvent, this));
        }
    }
    setPlayerDoNoActionCount(playerId) {
        Logger_1.logger.trace('setPlayerDoNoActionCount', playerId);
        const player = this.getPlayerById(playerId);
        if (player) {
            player.doNoActionCount = 0;
        }
    }
    showCardsForTeacher() {
        Logger_1.logger.trace('showCardsForTeacher');
        this.update(TableEvent_1.TableEvents.showCardsForTeacherEvent(this));
    }
    hideCardsForTeacher() {
        Logger_1.logger.trace('hideCardsForTeacher');
        this.update(TableEvent_1.TableEvents.hideCardsForTeacherEvent(this));
    }
    sitoutPlayerByTeacher(playerId) {
        Logger_1.logger.trace('sitoutPlayerByTeacher', playerId);
        const player = this.getPlayerById(playerId);
        if (player) {
            player.foreverOut();
        }
        this.update(TableEvent_1.TableEvents.playerForeverOutEvent(this, player));
        if (this.isCurrentPlayer(playerId)) {
            this.nextTurn();
        }
    }
    playerInByTeacher(playerId) {
        Logger_1.logger.trace('playerInByTeacher', playerId);
        const player = this.getPlayerById(playerId);
        if (player) {
            player.wait();
        }
        this.update(TableEvent_1.TableEvents.playerWaitlistedEvent(this, player));
        if (this.isCurrentPlayer(playerId)) {
            this.nextTurn();
        }
    }
    setColorForPlayer(playerId) {
        Logger_1.logger.trace('setColorForPlayer', playerId);
        const colors = config.PLAYERS_COLORS;
        const player = this.getPlayerById(playerId);
        if (player) {
            for (var i = 0; i < colors.length; i++) {
                const checkColor = this.players.find((p) => p.color === colors[i] && p.getId() !== player.getId());
                if (!checkColor) {
                    player.color = colors[i];
                    break;
                }
            }
        }
    }
    setTournamentBlinds() {
        Logger_1.logger.trace('setTournamentBlinds');
        this.bigBlind = config.TOURNAMENT_BIG_BLIND;
        this.blinds = new Blind_1.Blind(this.bigBlind);
        this.nextBlinds = new Blind_1.Blind(this.bigBlind * 2);
        this.mode = GameMode_1.GameModes.Tournament;
    }
    calculateNextBlinds() {
        Logger_1.logger.trace('calculateNextBlinds');
        const currentIndex = config.BLIND_LEVELS.indexOf(this.blinds.big);
        let countDown = this.blindTimerCountdown;
        if (currentIndex >= 0) {
            countDown = countDown * (currentIndex + 2);
        }
        Logger_1.logger.info(`${countDown} countDown`);
        if (GameMode_1.GameModes.isTournament(this.mode) &&
            currentIndex !== config.BLIND_LEVELS.length - 2) {
            this.blinds.big = this.nextBlinds.big;
            this.blinds.small = this.nextBlinds.small;
            const next = this.fetchNextBlinds();
            this.nextBlinds.big = next.big;
            this.nextBlinds.small = next.small;
            let nextIndex = config.BLIND_LEVELS.indexOf(next.big);
            this.nextBlindIndex = nextIndex;
            nextIndex = nextIndex + 2;
            this.blindTimerCheckpoint =
                this.blindTimerCheckpoint + nextIndex * this.blindTimerCountdown * 60000;
        }
        else {
            this.blinds.big = this.nextBlinds.big;
            this.blinds.small = this.nextBlinds.small;
            this.nextBlinds.big = 0;
            this.nextBlinds.small = 0;
        }
        this.update(TableEvent_1.TableEvents.calculateNextBlindEvent(this, this.getCurrentPlayer()));
    }
    fetchNextBlinds() {
        Logger_1.logger.trace('fetchNextBlinds');
        let nextBigBlinds = config.BLIND_LEVELS[0];
        if (this.blinds.big >= nextBigBlinds) {
            const nextIndex = config.BLIND_LEVELS.indexOf(this.blinds.big);
            nextBigBlinds = config.BLIND_LEVELS[nextIndex + 1];
        }
        return { big: nextBigBlinds, small: nextBigBlinds / 2 };
    }
    playerRemovedByTeacher(playerId) {
        Logger_1.logger.trace('playerRemovedByTeacher');
        const player = this.getPlayerById(playerId);
        this.update(TableEvent_1.TableEvents.playerRemovedByTeacherEvent(this, player));
    }
    setPlayerBuyIn(playerId) {
        Logger_1.logger.trace('setPlayerBuyIn', playerId);
        const player = this.getPlayerById(playerId);
        if (player) {
            player.setBuyIn();
            this.update(TableEvent_1.TableEvents.setPlayerBuyInEvent(this, player));
        }
    }
}
__decorate([
    class_transformer_1.Type(() => Board_1.Board),
    __metadata("design:type", Board_1.Board)
], Table.prototype, "board", void 0);
__decorate([
    class_transformer_1.Type(() => Blind_1.Blind),
    __metadata("design:type", Blind_1.Blind)
], Table.prototype, "blinds", void 0);
__decorate([
    class_transformer_1.Type(() => Blind_1.Blind),
    __metadata("design:type", Blind_1.Blind)
], Table.prototype, "nextBlinds", void 0);
__decorate([
    class_transformer_1.Type(() => Player_1.Player),
    __metadata("design:type", Array)
], Table.prototype, "players", void 0);
__decorate([
    class_transformer_1.Type(() => Player_1.Player),
    __metadata("design:type", Array)
], Table.prototype, "leftPlayers", void 0);
__decorate([
    class_transformer_1.Type(() => Bet_1.Bet),
    __metadata("design:type", Bet_1.Bet)
], Table.prototype, "lastBet", void 0);
__decorate([
    class_transformer_1.Type(() => GameState_1.GameStates),
    __metadata("design:type", Object)
], Table.prototype, "state", void 0);
__decorate([
    class_transformer_1.Type(() => GameMode_1.GameModes),
    __metadata("design:type", Object)
], Table.prototype, "mode", void 0);
__decorate([
    class_transformer_1.Type(() => rxjs_1.Subject),
    __metadata("design:type", Object)
], Table.prototype, "event$", void 0);
exports.Table = Table;
//# sourceMappingURL=Table.js.map